import { client } from "../../../Infrastructure/agent";

export const menuService = {
  getAppMenu: () => client.get(`/main/getapplicationmenu`),
  resetPassword: (email) => client.post(`/main/ResetPassword`, { email }),
  getAssets: () => client.get(`/main/GetAssets`),
};

